import type { DraftRuleId } from '@/rules-management/domain/DraftRule.ts';
import type { RulesRepository } from '@/rules-management/domain/RulesRepository.ts';

export class DraftRulesPublication {
  readonly #published: DraftRuleId[];
  readonly #failed: DraftRuleId[];

  private constructor(published: DraftRuleId[], failed: DraftRuleId[]) {
    this.#published = published;
    this.#failed = failed;
  }

  static of({
    published,
    failed,
  }: {
    published: DraftRuleId[];
    failed: DraftRuleId[];
  }): DraftRulesPublication {
    return new DraftRulesPublication(published, failed);
  }

  get failed(): DraftRuleId[] {
    return this.#failed;
  }

  get publishedCount(): number {
    return this.#published.length;
  }

  get failedCount(): number {
    return this.#failed.length;
  }

  get hasFailed(): boolean {
    return this.failedCount > 0;
  }

  get hasPublished(): boolean {
    return this.publishedCount > 0;
  }
}

export const publishDraftRules = (
  repository: RulesRepository,
  ids: DraftRuleId[],
): Promise<DraftRulesPublication> =>
  Promise.allSettled(ids.map((id) => repository.publish(id))).then((results) =>
    DraftRulesPublication.of({
      published: ids.filter((_, index) => results[index].status === 'fulfilled'),
      failed: ids.filter((_, index) => results[index].status === 'rejected'),
    }),
  );
